<template>
    <nav class="main-nav" v-if="isOpen">
        <div class="container">
            <ul class="list-reset">
                <ListItem
                    v-for="(item, key) in items.menuItems"
                    :key="key"
                    :index="key"
                    :data="item"
                    :all-text="allText"
                />
            </ul>
        </div>
    </nav>
</template>

<script>
import { onMounted, reactive, toRefs, inject } from 'vue'

import ListItem from './ListItem'

export default {

    props: [
        'items',
        'allText'
    ],

    components: {
        ListItem
    },

    setup(props) {

        const state = reactive({
            // menuItems: props.items,
            isOpen: true,
            megaMenuOpen: false
        })

        const emitter = inject('emitter')
        const viewport = window.innerWidth

        onMounted( () => {
            // console.log(props.items)
            if ( viewport < 1199 ) state.isOpen = false

            emitter.on('menu-open', (result) => state.isOpen = result)
            // emitter.on('megamenu-open', (result) => state.megaMenuOpen = result )
        })

        return {
            ...toRefs(state)
        }
    }
}
</script>
